import _ from 'lodash';

export function canUpperCaseChar(string, pos) {
  return string.charCodeAt(pos) < 126;
}

export function uppercaseName(name) {
  return _.toUpper(name);
}

export function capitalizeName(name) {
  // normalize capitalization of primary actor. Armory results will be
  // capitalized, but only perform on ASCII first char
  if (canUpperCaseChar(name, 0)) {
    return _.capitalize(name);
  }
  return name;
}
